export default function initConstructionUpdates() {
    const container = document.getElementById('construction-updates-results');
    if (!container) return;

    let currentPage = 1;
    let maxPages =
        parseInt(
            container.querySelector('.construction-updates__load-more')?.dataset.maxPages
        ) || 1;
    let isLoading = false;

    container.addEventListener('click', (e) => {
        const btn = e.target.closest('.construction-updates__load-more');
        if (!btn || isLoading) return;

        currentPage++;
        isLoading = true;
        btn.disabled = true;
        btn.textContent = 'Loading...';

        fetch(constructionUpdates.ajaxurl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                action: 'load_more_construction_updates',
                nonce: constructionUpdates.nonce,
                page: currentPage,
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (!data.success) return;

                maxPages = data.data.max_pages;

                const list = container.querySelector('.construction-updates__list');
                if (list && data.data.html) {
                    const temp = document.createElement('div');
                    temp.innerHTML = data.data.html;
                    const newItems = temp.querySelectorAll('.post-item');
                    const firstNew = newItems[0] || null;

                    while (temp.firstChild) {
                        list.appendChild(temp.firstChild);
                    }

                    if (firstNew) {
                        firstNew.setAttribute('tabindex', '-1');
                        firstNew.focus({ preventScroll: false });
                    }
                }

                if (currentPage >= maxPages) {
                    const wrapper = container.querySelector(
                        '.construction-updates__load-more-wrapper'
                    );
                    if (wrapper) wrapper.remove();
                } else {
                    btn.disabled = false;
                    btn.textContent = 'Load More';
                }
            })
            .catch((err) => {
                console.error('Construction updates load more error:', err);
                btn.disabled = false;
                btn.textContent = 'Load More';
            })
            .finally(() => {
                isLoading = false;
            });
    });
}
